import { render, staticRenderFns } from "./DiffViewer.vue?vue&type=template&id=6a40bbda&scoped=true"
import script from "./DiffViewer.vue?vue&type=script&lang=ts"
export * from "./DiffViewer.vue?vue&type=script&lang=ts"
import style0 from "./DiffViewer.vue?vue&type=style&index=0&id=6a40bbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40bbda",
  null
  
)

export default component.exports